<template>
  <button class="cubeProject" @click.stop="$emit('select')">
    <div :style="[color ? { backgroundColor: color }:{}]">
      <div class="projectId">{{item.projectId}}</div>
    </div>
    <div>
      <div class="projectName"
      :style="[color ? { color: color }:{}]">{{item.projectName}}</div>
    </div>
  </button>
</template>

<script>
export default {
  props: ['item', 'color']

}
</script>

<style lang="scss" scoped>
.cubeProject {
  width: 276px;
  max-width: 276px;
  height: 190px;
  box-shadow: 0px 3px 4px 0px #00000040;
  display: grid;
  grid-template-rows: 110px 1fr;
  border-radius: 5px;
  background-color: #C4C4C4;
  &> div {
    max-width: 276px;
    display: flex;
    align-items: flex-end;
    justify-content: flex-start;
    padding: 12px 18px;
    text-align: start;
    &:nth-child(2) {
      background-color: #FFFFFF;
      align-items: flex-start;
      font-size: 18px;
      color: #CACACA;
      border-radius: 0 0 5px 5px;
    }
    &:nth-child(1) {
      background-color: #CACACA;
      border-radius: 5px 5px 0 0;
    }
    .projectId {
      color: #FFFFFF80;
      font-weight: 700;
      font-size: 26px;
      letter-spacing: .02em;
      white-space:nowrap;
      overflow:hidden;
      text-overflow: ellipsis;
      text-align: start;

    }
  }
}
</style>
